import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { NGXLogger } from 'ngx-logger';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private logger = inject(NGXLogger);

  getTranslation(lang: string) {
    this.logger.debug(
      `[TranslocoHttpLoader] Loading language file '/assets/i18n/${lang}.json'`,
    );
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
